import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class AccessClaimModel extends Model implements IModel<AccessClaimModel> {
  public companyGroupId: string = '';
  public title: string = '';
  public description: string = '';
  public actionsDetails: any[] = [];

  static create(input: any): AccessClaimModel {
    return ObjectMapper.deserialize<AccessClaimModel>(AccessClaimModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
